module.exports = __webpack_public_path__ + "img/mgh-toyosu-bayside-cross-tokyo.181c91b6.jpg";